<template>
  <div id="editLinkman">
    <div v-if="!editMode">
      <a-row style="padding:14px 0 11px 0;" v-if="!hideEdit">
        <div @click="toEditMode" >
          <pt-icon type="icon-bianji1" class="edit_icon"></pt-icon>
        </div>
      </a-row>
      <a-row v-for="linkMan,index in linkmanDOS" v-bind:key="index" style="padding: 0 20px;">
        <div class="linkman">
          <div class="linkman_icon">
            <pt-icon type="icon-lianxiren3" style="font-size:35px;"></pt-icon>
          </div>
          <div style="flex: 1;">
            <a-row class="linkman_title">
              <a-col :span="6">{{$t('deal.addDeal.linkMan.name')}}</a-col>
              <a-col :span="6">{{$t('deal.addDeal.linkMan.job')}}</a-col>
              <a-col :span="6">{{$t('deal.addDeal.linkMan.phone')}}</a-col>
              <a-col :span="6">{{$t('deal.addDeal.linkMan.email')}}</a-col>
            </a-row>
            <a-row class="linkman_content">
              <a-col :span="6">{{linkMan.name}}</a-col>
              <a-col :span="6">{{linkMan.job}}</a-col>
              <a-col :span="6">{{linkMan.phone}}</a-col>
              <a-col :span="6">{{linkMan.email}}</a-col>
            </a-row>
          </div>
        </div>
      </a-row>
    </div>
    <div v-else>
      <a-row class="save_buttons">
        <a-button @click="cancelEditMode" style="margin-right: 5px;">{{$t('baseVO.cacel')}}</a-button>
        <a-button type="primary" @click="submit">{{$t('baseVO.save')}}</a-button>
      </a-row>
      <a-form :form="forms" layout="vertical">
        <a-row v-for="form,index in tempLinkmanDOS " v-bind:key="index" >
          <a-form-item v-show="false">
            <a-input v-decorator="[`linkmanDOS[${index}].id`,{}]"></a-input>
          </a-form-item>
          <a-form-item v-show="false">
            <a-input v-decorator="[`linkmanDOS[${index}].version`,{}]"></a-input>
          </a-form-item>
          <a-col :span="6">
            <a-form-item :label="index == 0 ? $t('deal.addDeal.linkMan.name') : ''">
              <a-input v-decorator="[`linkmanDOS[${index}].name`,{rules: [
                {required: true,message: $t('linkman.modal.nameCNTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                ],}]"
              :placeholder="$t('linkman.modal.nameCNTip')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="index == 0 ? $t('deal.addDeal.linkMan.job') : ''">
              <ptInput v-decorator="[`linkmanDOS[${index}].job`,{rules: [
                {required: true,message: $t('linkman.modal.jobTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                ],}]"
                       :placeholder="$t('linkman.modal.jobTip')"></ptInput>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="index == 0 ? $t('deal.addDeal.linkMan.phone') : ''">
              <ptInput v-decorator="[`linkmanDOS[${index}].phone`,{rules: [
                {required: true,message: $t('linkman.modal.mobilePhoneTip'),},
                {min: 2, max: 64, message: $t('linkman.modal.textMinLength'), trigger: 'blur'},
                {pattern:/(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}/, message:$t('customer.customerModal.phoneErrorTip'), trigger: 'blur'},
                ],}]"
                       :placeholder="$t('linkman.modal.mobilePhoneTip')"></ptInput>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item :label="index == 0 ? $t('deal.addDeal.linkMan.email') : ''">
              <ptInput
                :placeholder="$t('linkman.modal.emailTip')"
                v-decorator="[`linkmanDOS[${index}].email`,{rules: [
                // {
                //   required: true, message:$t('linkman.modal.emailTip')
                // },
                  {
                    type: 'email',
                    message:$t('customer.customerModal.emailErrorTip'),
                  },
                  {min: 2, max: 256, message: $t('customer.customerModal.textMaxLength'), trigger: 'blur'},
                ],}]">
                <!--<a-popconfirm-->
                  <!--:title="$t('linkman.deleteLinkman')"-->
                  <!--@confirm="deleteLinkman(index)"-->
                  <!--okText="Yes"-->
                  <!--cancelText="No"-->
                  <!--slot="addonAfter"-->
                <!--&gt;-->
                  <div @click="deleteLinkman(index)">
                    <pt-icon type="icon-tubiao" class="delete_icon"></pt-icon>
                  </div>
                <!--</a-popconfirm>-->
              </ptInput>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div style="padding-left: 10px;">
        <pt-newObjectTag @click="addLinkMan"></pt-newObjectTag>
      </div>
    </div>
  </div>
</template>

<script>
  import dealApi from '@/api/mine/dealLinkman'
  import pursuitsApi from '@/api/mine/pursuitsLinkman'
  export default {
    name: 'editLinkman',
    props: {
      hideEdit:{
        type:Boolean,
        default:false,
      },
      linkmanDOS:{
        type: Array,
        default:[]
      },
      dealId:{
        type: String,
        default: null
      },
      pursuitsId:{
        type: String,
        default: null
      }
    },
    data() {
      return {
        forms:this.$form.createForm(this,{}),
        editMode: false,
        tempLinkmanDOS:[]
      }
    },
    mounted() {
    },
    methods: {
      addLinkMan(){
        this.tempLinkmanDOS.push({})
      },
      cancelEditMode(){
        this.editMode = false
        this.$emit('cancelEdit')
      },
      deleteLinkman(index){
        let this_ = this
        this.$ptConfirm({
          content: _this.$t('linkman.deleteLinkman'),
          okType: 'primary',
          onOk() {
            _this.tempLinkmanDOS.splice(index,1)
            _this.$nextTick(()=>{
              _this.forms.setFieldsValue({linkmanDOS:this.tempLinkmanDOS})
            })
          },
          onCancel() {

          },
        });
      },
      prepareForms(){
        this.tempLinkmanDOS = JSON.parse(JSON.stringify(this.linkmanDOS))
        this.$nextTick(()=>{
          this.forms.setFieldsValue({linkmanDOS:this.linkmanDOS})
        })
      },
      submit(){
        this.forms.validateFieldsAndScroll(err=>{
          if(!err){
            let linkmanForms = this.forms.getFieldsValue().linkmanDOS
            if(!linkmanForms){
              linkmanForms = []
              this.$message.warning(this.$t('linkman.addContactTip'))
              return
            }
            if(this.dealId != null){
              dealApi.updateLinkmanDOS(this.dealId,linkmanForms).then(res=>{
                if(res.code == 1){
                  this.$message.success(res.message)
                  this.$emit('saveSuccess')
                  this.cancelEditMode()
                }else{
                  this.$message.error(res.message)
                }
              })
            }else if(this.pursuitsId != null){
              pursuitsApi.updateLinkmanDOS(this.pursuitsId,linkmanForms).then(res=>{
                if(res.code == 1){
                  this.$message.success(res.message)
                  this.$emit('saveSuccess')
                  this.cancelEditMode()
                }else{
                  this.$message.error(res.message)
                }
              })
            }

          }
        })
      },
      toEditMode(){
        this.editMode = true
        this.prepareForms()
      },
    },
  }
</script>

<style scoped lang="less">
  #editLinkman{
    .linkman{
      display: flex;
      border: 1px solid #EFF1F5;
      align-items: center;
      margin-bottom: 10px;
      .linkman_icon{
        padding: 10px 15px;
        background-color: #FBFBFC;
        margin-right: 10px;
      }
      .linkman_title{
        font-size: 12px;
        color: #999999;
      }
      .linkman_content{
        font-size: 12px;
        color: #333333;
      }
    }
    .save_buttons{
      display: flex;
      justify-content: flex-end;
      padding-top: 5px;
    }
    .edit_icon{
      font-size: 18px;
      float:right;
      cursor:pointer;
    }
    .ant-form-vertical .ant-form-item{
      padding: 0 10px;
    }
  }
</style>